import type { ButtonProps as AriaButtonProps } from 'react-aria-components';
import { Button as AriaButton } from 'react-aria-components';

import { cn } from '@infinex/ui-styles';

import { useCurrencyUnit } from './CurrencyUnitProvider';

type SwitchUnitButtonProps = Omit<AriaButtonProps, 'onPress'>;
export function SwitchUnitButton(props: SwitchUnitButtonProps) {
  const { unit, updateUnit } = useCurrencyUnit();

  return (
    <AriaButton
      {...props}
      className={cn(
        'text-secondary rounded-xsmall relative flex items-center ps-1 outline-hidden',
        'hover:text-default',
        'focus-visible:outline-focusRingInside',
        // increase hit area on touch devices
        'pointer-coarse:after:h-min-touch-target pointer-coarse:after:absolute pointer-coarse:after:w-full',
        props.className
      )}
      onPress={() => updateUnit(unit === 'token' ? 'usd' : 'token')}
    />
  );
}
